<div class="flex-1 flex flex-col gap-2">
  <dx-form
    [formData]="formData"
    (onFieldDataChanged)="onFieldDataChanged()"
    [colCount]="3"
  >
    <dxi-item
      dataField="title"
      [label]="{
        text: 'Titolo' | transloco,
        location: 'left',
        visible: true
      }"
      [editorOptions]="{ placeholder: '' | transloco }"
    ></dxi-item>
    <dxi-item
      dataField="cols"
      editorType="dxSelectBox"
      [label]="{ text: 'Colonne' | transloco, location: 'left' }"
      [editorOptions]="{ dataSource: [2, 3, 4, 5, 6] }"
    ></dxi-item>

    <dxi-item>
      <div *dxTemplate class="flex flex-row items-center justify-end">
        <snt-button
          icon="fa-light fa-plus"
          [title]="'Aggiungi campo' | transloco"
          (onClick)="onAddField()"
        ></snt-button>
      </div>
    </dxi-item>
  </dx-form>

  <div class="grid {{ 'grid-cols-' + (this.item.config.cols || '2') }} gap-2">
    @for (
      field of item.config.items;
      track field;
      let index = $index;
      let isFirst = $first;
      let isLast = $last
    ) {
      <div
        class="p-2 flex flex-row items-center gap-2 rounded-md border-2 border-slate-100"
      >
        <div>
          <span class="text-base text-slate-900 font-medium">
            {{ field.title }}
          </span>
        </div>
        <div class="flex flex-row gap-2 ml-auto">
          <snt-button-icon
            icon="fa-light fa-angle-up"
            [disabled]="isFirst"
            [size]="'xs'"
            (onClick)="onMoveUpField(index)"
          ></snt-button-icon>
          <snt-button-icon
            icon="fa-light fa-angle-down"
            [disabled]="isLast"
            [size]="'xs'"
            (onClick)="onMoveDownField(index)"
          ></snt-button-icon>
          <snt-button-icon
            icon="fa-light fa-trash"
            [size]="'xs'"
            (onClick)="onRemoveField(field)"
          ></snt-button-icon>
        </div>
      </div>
    }
  </div>
</div>
